import React from "react";
import { MaterialIcons } from "@expo/vector-icons";

import AddImageBaseCard from "@/Components/Media/User/Images/AddImageBaseCard";

interface Props {
  handleImageUpload: () => void;
  numColumns: number;
  isPrivateTab: boolean;
}

function AddImageCard({
  handleImageUpload,
  numColumns,
  isPrivateTab,
}: Props): React.JSX.Element {
  const iconComponent = (
    <MaterialIcons name="add-a-photo" size={36} color="white" />
  );

  const title = isPrivateTab
    ? "Your Choice, Your Privacy"
    : "Your Face, Your Identity";

  const subtitle = isPrivateTab
    ? "🔒 Photos in your private album stay hidden until you approve someone's request to view them."
    : "Upload real photos so others can connect with the real you.";

  const bottomTags = isPrivateTab
    ? ["👀 (N)SFW", "🌈 Be Yourself"]
    : ["👀 SFW", "🌈 Be Yourself"];

  return (
    <AddImageBaseCard
      handleImageUpload={handleImageUpload}
      numColumns={numColumns}
      iconComponent={iconComponent}
      title={title}
      subtitle={subtitle}
      bottomTags={bottomTags}
    />
  );
}

export default AddImageCard;
